import { ProductType } from '@/components/modules/Funnel/types/ProductType';
import { getStepsDefinitions } from '@/components/modules/Funnel/utils/GetStepsDefinitions';

export const getStepsUntilNextMilestoneByStepKey = (stepKey: number, selectedProductType: ProductType) => {
  const nextSteps = getStepsDefinitions(selectedProductType).slice(stepKey);
  const nextMilestoneKey = nextSteps.slice(1).findIndex((s) => s.associatedMilestone);
  return nextMilestoneKey !== -1 ? nextSteps.slice(0, nextMilestoneKey + 1) : nextSteps;
};
